/**
 * Created by lzy 19-11-04
 * 添加百家号账号模块
 */
'use strict';
angular.module('productManageMentQiehaoAccountAddModule', []).controller('ProductManageMentQiehaoAccountAddCtrl', ['$scope', '$modalInstance', '$validation', 'trsHttpService', 'item',
    function($scope, $modalInstance, $validation, trsHttpService, item) {
        initStatus();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            // $scope.data = {
            //     currUser: {
            //         sinaLoginUserName: '',
            //         isActive: '1'
            //     }
            // };
            $scope.data = {
                currUser: {
                    Objectid: item ? item.KUAIBAOACCOUNTID : 0,
                    ClientID: item ? item.CLIENTID : '',
                    ClientSERCRET: item ? item.CLIENTSERCRET : '',
                    // isActive: item ? item.ISACTIVE : 1,
                    ISPAICHONG: item ? item.ISPAICHONG : '0',
                    CKMSIMDAYRANGE: item ? item.CKMSIMDAYRANGE : '',
                    serviceid: 'mlf_kuaibaoaccount',
                    methodname: 'save',
                }
            };
        }

        /**
         * [checkProperty description] 是否检查稿件属性
         * @return {[type]} [description]
         */
        $scope.checkProperty = function() {
            $scope.data.currUser.isActive = $scope.data.currUser.isActive == '0' ? '1' : '0';
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            // var params = {
            //     serviceid: 'mlf_kuaibaoaccount',
            //     methodName: 'save',
            //     Objectid: 0,
            //     accountName: $scope.data.currUser.accountName,
            //     ClientID: $scope.data.currUser.ClientID,
            //     ClientSERCRET: $scope.data.currUser.ClientSERCRET
            // };
            $scope.accountForm.$pending = {};
            $validation.validate($scope.accountForm).success(function() {
                LazyLoad.js(['./lib/js-base64/base64.js'], function() {
                    // params.sinaUserLoginPwd = Base64.encode(angular.copy($scope.data.currUser.sinaUserLoginPwd));
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', $scope.data.currUser, 'post', true).then(function(data) {
                        $modalInstance.close({result: true});
                    }, function(data) {
                        $modalInstance.close({result: false, data: data});
                    });
                });
            });
        };
    }
]);
